import {
  loaders,
  Texture,
  Sprite,
  RenderTexture,
  Container,
  utils,
} from 'pixi.js';

import 'pixi-spine';
import 'pixi-particles';
import 'pixi-projection';

import stopList from './data/stopList.json';

import {
  SIZES,
  SIZE_TYPES,
} from './constants';

const loading = {};

export const channelMax = 255;

export function getSprite(key) {
  if (stopList.find(item => key.includes(item))) {
    return new Sprite(Texture.EMPTY);
  }

  return new Sprite(Texture.fromImage(key));
}

export async function loadTextures(textures, baseUrl) {
  return Promise.all(textures
    .map(path => loadTexture(`${baseUrl}/${path}`, `${baseUrl}/${path}.png`)));
}

export function renderSprite(sprite, spriteRenderer, size = SIZE_TYPES.SMALL_2X) {
  const container = sprite;
  const resultTexture = RenderTexture.create(SIZES[size].width, SIZES[size].height);

  container.width = SIZES[size].width;
  container.height = SIZES[size].height;

  spriteRenderer.render(container, resultTexture);
  container.destroy();

  return resultTexture;
}

export function mergeTwoTextures(textureA, textureB, spriteRenderer, size) {
  const container = new Container();
  const spriteA = new Sprite(textureA);
  const spriteB = new Sprite(textureB);

  container.addChild(spriteA);
  container.addChild(spriteB);

  const resultSprite = renderSprite(container, spriteRenderer, size);

  container.destroy({ children: true });

  return resultSprite;
}

export async function loadTexture(key, realPath) {
  if (loading[key]) {
    return loading[key];
  }

  const promise = new Promise(async (resolve, reject) => {
    if (utils.TextureCache[realPath]) {
      if (!utils.TextureCache[key]) {
        utils.TextureCache[key] = utils.TextureCache[realPath];
      }

      loading[key] = null;
      resolve(utils.TextureCache[realPath]);
    } else if (utils.TextureCache[key]) {
      utils.TextureCache[realPath] = utils.TextureCache[key];
      loading[key] = null;
      resolve(utils.TextureCache[key]);
    } else if (stopList.find(item => key.includes(item))) {
      loading[key] = null;
      resolve(null);
    } else {
      const loader = new loaders.Loader();

      loader.add(key, realPath);
      loader.load(({ resources }) => {
        const resource = resources[key];

        loading[key] = null;

        if (resource.error) {
          utils.TextureCache[key] = null;
          utils.TextureCache[realPath] = null;
          reject(resource.error);
        } else if (resource.extension !== 'png') {
          utils.TextureCache[key] = null;
          utils.TextureCache[realPath] = null;
          reject(new Error('Wrong file extension'));
        } else {
          if (!utils.TextureCache[key]) {
            utils.TextureCache[key] = resource.texture;
          }

          resolve(utils.TextureCache[key]);
        }
      });
    }
  });

  loading[key] = promise;

  return promise;
}
